import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { TextField, InputAdornment, IconButton } from '@mui/material';
import VisibilityRoundedIcon from '@mui/icons-material/VisibilityRounded';
import VisibilityOffRoundedIcon from '@mui/icons-material/VisibilityOffRounded';

 /**
  * FormTextField — outlined TextField with optional leading icon.
  * Inherits theme styling (radius 12, BG2 background, focus blue).
  * Used by Login + Register for username / email / password-confirm.
  */
export const FormTextField = ({
  icon: Icon,
  inputProps = {},
  ...props
}) => (
  <TextField
    {...props}
    InputProps={{
      ...(props.InputProps || {}),
      startAdornment: Icon ? (
        <InputAdornment position="start" sx={{ color: 'text.secondary', mr: 0.5 }}>
          <Icon fontSize="small" />
        </InputAdornment>
      ) : null,
    }}
  />
);

FormTextField.propTypes = {
  icon: PropTypes.elementType,
  InputProps: PropTypes.object,
  inputProps: PropTypes.object,
};

 /**
  * PasswordField — TextField with visibility toggle.
  * Wraps FormTextField, manages its own show/hide state.
  */
const PasswordField = ({ icon, ...props }) => {
  const [show, setShow] = useState(false);

  return (
    <FormTextField
      {...props}
      type={show ? 'text' : 'password'}
      icon={icon}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label={show ? 'Ocultar contraseña' : 'Mostrar contraseña'}
              onClick={() => setShow((s) => !s)}
              edge="end"
              size="small"
              sx={{ color: 'text.secondary' }}
            >
              {show ? <VisibilityOffRoundedIcon fontSize="small" /> : <VisibilityRoundedIcon fontSize="small" />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};

PasswordField.propTypes = {
  icon: PropTypes.elementType,
};

export default PasswordField;